// export __webpack_public_path__ for webpack compiler
const script = document.querySelector('script.index.bundle')
const src = script.getAttribute('src')
// eslint-disable-next-line no-undef
__webpack_public_path__ = src.substr(0, src.lastIndexOf('/') + 1)
